module.exports = __webpack_public_path__ + "static/media/lily.05dad509.jpg";